import {Box, Grid, Paper, Typography} from "@mui/material"
import React, {useState, useEffect} from "react"
import AlertMessage from "src/components/alert-message"
import {RoutineService} from "src/services/routine-service"
import {DataGrid} from "@mui/x-data-grid"
import SkeletonTable from "src/components/skeleton-table"

const DailyRoutinesReportPage = () => {
    const [loading, setLoading] = useState(false)
    const [alertMessageState, setAlertMessageState] = useState({open: false, message: "", type: ""})
    const [columns, setColumns] = useState([])
    const [tableData, setTableData] = useState([])

    const routineService = new RoutineService()

    const closeAlert = () => setAlertMessageState({...alertMessageState, open: false})
    const openAlert = (message, type) => setAlertMessageState({open: true, message, type})

    const carregarRelatorioTodasRotinas = () => {
        setLoading(true)
        setColumns([])
        setTableData([])

        routineService.startarRelatorioTabelaCalculo()
            .then((response) => {
                try {
                    const jsonData = JSON.parse(response.text)
                    const rotinaData = jsonData.relatorio_rotina

                    if (!Array.isArray(rotinaData) || rotinaData.length === 0) {
                        openAlert("Nenhum dado disponível.", "info")
                        return
                    }

                    const generatedColumns = Object.keys(rotinaData[0]).map((key) => ({
                        field: key,
                        headerName: key,
                        width: 150
                    }))

                    const table = rotinaData.map((item, index) => ({
                        id: index,
                        ...item
                    }))

                    setColumns(generatedColumns)
                    setTableData(table)
                } catch (err) {
                    console.error("Erro ao processar resposta:", err)
                    openAlert("Erro ao processar resposta.", "error")
                } finally {
                    setLoading(false)
                }
            })
            .catch((error) => {
                console.error("Erro ao buscar dados:", error)
                openAlert("Erro ao buscar dados.", "error")
                setLoading(false)
            })
    }

    useEffect(() => {
        carregarRelatorioTodasRotinas()
    }, [])

    return (
        <div>
            <AlertMessage {...alertMessageState} close={closeAlert}/>
            <Box sx={{width: "auto"}}>
                <Grid container alignItems="flex-start" justifyContent="flex-start" spacing={3}>
                    <Grid item sm={12} md={6} xl={4} xs={12}>
                        <Typography variant="h5">Relatório Rotinas Noturnas</Typography>
                    </Grid>
                </Grid>
            </Box>

            <br/>
            <Paper>
                <Grid container>
                    <Grid item xs={12}>
                        {loading ? (
                            <SkeletonTable/>
                        ) : (
                            <div style={{height: 600, width: "100%"}}>
                                <DataGrid
                                    rows={tableData}
                                    columns={columns}
                                    getRowId={(row) => row.id}
                                    pageSize={5}
                                    rowsPerPageOptions={[5]}
                                    sx={{fontSize: '0.7rem'}}
                                />
                            </div>
                        )}
                    </Grid>
                </Grid>
            </Paper>
        </div>
    )
}

export default DailyRoutinesReportPage
